var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.5,22h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S43.052,22,42.5,22z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#ff6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,16h10c0.552,0,1-0.447,1-1s-0.448-1-1-1h-10c-0.552,0-1,0.447-1,1S16.948,16,17.5,16z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#ff6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5,30h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S43.052,30,42.5,30z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#ff6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5,38h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S43.052,38,42.5,38z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#ff6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5,46h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S43.052,46,42.5,46z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#ff6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.914,0H6.5v60h47V14.586L38.914,0z M39.5,3.414L50.086,14H39.5V3.414z M8.5,58V2h29v14h14v42H8.5z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#ff6600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileOrange);
export default __webpack_public_path__ + "static/media/file-orange.488456acc9bc327ba9993cfeb8c5d097.svg";
export { ForwardRef as ReactComponent };